module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><a href = "/#relationtype/'+
((__t=( id ))==null?'':__t)+
'">'+
((__t=( name ))==null?'':__t)+
'</a></td>\r\n<td><div data-toggle="tooltip" title="'+
((__t=( fullDescription ))==null?'':__t)+
'">'+
((__t=( description ))==null?'':__t)+
'</div></td>\r\n<td>'+
((__t=( parentType ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( childType ))==null?'':__t)+
'</td>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/relationtypes/relationtype-item.html
// module id = 433
// module chunks = 0